/**
 * REM-MOB-03 (full) — the blocking force-update screen.
 *
 * Shown by <VersionGate> when the running binary is BELOW the backend-declared minimum supported
 * version. It fully replaces the app surface (no children render behind it) so an out-of-date client
 * cannot reach screens that would fail on a breaking API change. The only action is "Update" (opens
 * the platform store); there is no dismiss — the gate re-evaluates on next launch once updated.
 *
 * Design-system primitives only; NEVER imports @smartbox/* (mobile invariant 1).
 */
import { Linking, Platform, StyleSheet, View } from 'react-native';
import { Screen, Text, Button } from './ui';
import { theme } from '../theme';
import { DOWNLOADS } from '../marketing/content';

export function storeUrlForPlatform(): string {
  return Platform.OS === 'ios' ? DOWNLOADS.ios.href : DOWNLOADS.android.href;
}

export function ForceUpdateScreen({ current, required }: { current: string; required: string }) {
  return (
    <Screen>
      <View style={styles.center}>
        <Text variant="display">Update required</Text>
        <Text variant="body" color="secondary">
          This version of BEAM is out of date and can no longer connect safely. Please update to
          continue.
        </Text>
        <Text variant="small" color="secondary" accessibilityLabel="Version detail">
          Installed {current} · minimum {required}
        </Text>
        <Button
          title="Update BEAM"
          variant="primary"
          onPress={() => {
            void Linking.openURL(storeUrlForPlatform());
          }}
          accessibilityLabel="Update BEAM"
        />
      </View>
    </Screen>
  );
}

const styles = StyleSheet.create({
  center: { flex: 1, justifyContent: 'center', gap: theme.spacing.lg },
});
